export const DESTINATION_CERTAINTY = [
  { value: "know_exactly", label: "I know exactly where I want to go" },
  { value: "few_places", label: "I have a few places in mind" },
  { value: "not_sure", label: "I don't know yet — help me choose" },
];

export const DATES_TYPE = [
  { value: "exact", label: "Fixed dates" },
  { value: "approximate", label: "Approximate month or flexible" },
  { value: "flexible", label: "No dates decided yet" },
];

export const DURATIONS = [
  { value: "weekend", label: "Weekend" },
  { value: "4-7", label: "4–7 days" },
  { value: "8-14", label: "8–14 days" },
  { value: "2+weeks", label: "2+ weeks" },
  { value: "not_sure", label: "Not sure" },
];

export const TRAVELLER_TYPES = [
  { value: "solo", label: "Solo" },
  { value: "couple", label: "Couple" },
  { value: "family", label: "Family" },
  { value: "friends", label: "Friends" },
  { value: "group", label: "Group" },
];

export const INTERESTS = [
  "Food & local restaurants",
  "Culture & history",
  "Beaches",
  "Nature & outdoors",
  "Nightlife",
  "Music & events",
  "Wellness & relaxation",
  "Adventure",
  "Shopping",
  "Art & design",
  "Local neighbourhoods",
  "Luxury",
  "Boutique hotels",
  "Slow travel",
];

export const PACE = [
  { value: "slow", label: "Slow & easy" },
  { value: "balanced", label: "Balanced" },
  { value: "see_all", label: "I want to see it all" },
];

export const TOURIST_PREFERENCE = [
  { value: "love_famous", label: "Love the famous spots" },
  { value: "few_fine", label: "A few are fine" },
  { value: "prefer_missed", label: "Prefer places most tourists miss" },
];

export const BUDGET_TIERS = [
  { value: "on_a_budget", label: "On a budget" },
  { value: "comfortable", label: "Comfortable" },
  { value: "premium", label: "Premium" },
  { value: "luxury", label: "Luxury" },
  { value: "no_fixed", label: "Not sure yet — help me understand the options" },
];

export const ACCOMMODATION = [
  { value: "boutique", label: "Boutique" },
  { value: "design_led", label: "Design-led" },
  { value: "luxury", label: "Luxury" },
  { value: "comfortable", label: "Comfortable & practical" },
  { value: "unique", label: "Unique / characterful" },
  { value: "no_preference", label: "No preference" },
];

export const STEPS = [
  { key: "destination", label: "Destination" },
  { key: "trip", label: "Your Trip" },
  { key: "style", label: "Your Style" },
  { key: "preferences", label: "Preferences" },
  { key: "details", label: "Review & Details" },
];

export const INITIAL_FORM = {
  destinationCertainty: "",
  destinations: [""],
  origin: "",
  datesType: "",
  travelDates: "",
  departDate: "",
  returnDate: "",
  duration: "",
  travellerType: "",
  numTravellers: "",
  interests: [],
  pace: "",
  touristPref: "",
  avoid: "",
  budget: "",
  accommodation: "",
  notes: "",
  name: "",
  email: "",
  phone: "",
  instagram: "",
  consent: false,
};
